import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { range } from 'underscore';
import {
  Action,
  State as QueryFilters,
  createQueryFilters,
} from '../Hooks/useQueryFilters';
import { usePropertiesQuery } from '../Repositories/usePropertiesQuery';
import { SRPCard } from './SRPCard';
import { SRPPagination } from './SRPPagination';

interface Props {
  state: QueryFilters;
  dispatch: React.Dispatch<Action>;
}

export function SRPList({ state, dispatch }: Props) {
  const { t } = useTranslation('search');
  const { isLoading, isError, isFetching, data } = usePropertiesQuery(
    createQueryFilters(state)
  );

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [state.currentPage]);

  return (
    <div className="flex-1 max-w-full p-5 min-h-[calc(100vh-162px)]">
      {isLoading || isFetching || isError || !data ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 3xl:grid-cols-3 gap-5">
          {range(30).map((element) => (
            <div
              key={element}
              className="rounded-lg bg-zinc-100 animate-pulse shadow-sm px-5 h-64"
            />
          ))}
        </div>
      ) : (
        <div>
          {data?.results?.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 min-[2200px]:grid-cols-3 gap-5">
              {data?.results?.map((element, idx) => (
                <SRPCard key={idx} data={element} />
              ))}
            </div>
          ) : (
            <div className="border border-dashed border-zinc-200 rounded-md h-64 grid place-items-center">
              <span className="text-zinc-800 font-semibold">
                {t('list.noResults')}
              </span>
            </div>
          )}
        </div>
      )}

      {data && data.results.length > 0 && (
        <div className="pt-8 pb-4">
          <SRPPagination
            totalItems={data.total}
            itemsPerPage={20}
            currentPage={state.currentPage || 1}
            onPageChange={(page) => {
              dispatch({ type: 'CHANGE_PAGE', payload: page });
            }}
          />
        </div>
      )}
    </div>
  );
}
